import React, { Component} from 'react'
import { Link } from 'react-router-dom'
import { trackToolUsage } from '../../../utils/Analytics'
// import { Circle } from 'react-color'
import $ from 'jquery'
// css
import './DrawHeader.css'

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      displayColorPicker: 'none',
      isBold: false,
      isItalic: false,
    }
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleColorOpen = this.handleColorOpen.bind(this)
    this.handleColorClose = this.handleColorClose.bind(this)
  }
  componentDidMount () {
    $('#size-small').addClass('enable')
    $('#marker').addClass('enable')
    document.addEventListener('mousedown', this.handleColorClose)
  }

  setWrapperRef (node) {
    this.wrapperRef = node
  }

  handleColorClose (event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ displayColorPicker: 'none' })
    }
  }

  handleColorOpen () {
    this.setState({ displayColorPicker: this.state.displayColorPicker === 'none' ? 'block' : 'none' })
    if(this.state.displayColorPicker === 'none') {
      this.props.setLastAction('select_tool');
    }
  }

  render () {
    return (
      <div id='draw-header'>
        <div className='header-outer-blk'>
          <div className='draw-logo-blk'>
            <Link to='/'>
              <img src={process.env.PUBLIC_URL + '/assets/images/ic_logo-black.svg'} className='draw-logo-img' alt='logo' />
            </Link>
            <div className='vr-line' />
            <Link to='/'>
              <img src={process.env.PUBLIC_URL + '/assets/images/ic_everforward-black.png'} className='ever-img' alt='logo' />
            </Link>
            <div className='mobile-draw-submit-blk noselect'>
              <div className='text-move-blk disable' id='text-move-blk'>Move Text</div>
              <img src={process.env.PUBLIC_URL + '/assets/images/icons/Info.png'} alt='info' onClick={this.props.startTour} style={{'cursor': 'pointer'}} />
              <div className='draw-submit-btn disable submit-mask' onClick={this.props.save}>submit mask</div>
            </div>
          </div>
          <div className='menu-blk'>
            <div className='tool-blk' ref='step1'>
              <img className='tool-img' id='marker' src={process.env.PUBLIC_URL + '/assets/images/icons/Marker.png'} alt='marker' onClick={() => this.props.setLastAction('select_tool')} />
              <img className='tool-img' id='crayon' src={process.env.PUBLIC_URL + '/assets/images/icons/Crayon.png'} alt='caron' onClick={() => this.props.setLastAction('select_tool')} />
              <img className='tool-img' id='eraser' src={process.env.PUBLIC_URL + '/assets/images/icons/Eraser.png'} alt='eraser' onClick={() => this.props.setLastAction('select_tool')} />
            </div>
            <div className='remove-blk'>
              <img className='undo-img' id='undo' src={process.env.PUBLIC_URL + '/assets/images/icons/Undo.png'} alt='eraser' onClick={() => {trackToolUsage('undo'); this.props.setLastAction('undo_drawing');}} />
            </div>
            <div className='size-blk'>
              <div className='size-brush' id='size-huge' onClick={() => this.props.setLastAction('select_tool')} />
              <div className='size-brush' id='size-large' onClick={() => this.props.setLastAction('select_tool')} />
              <div className='size-brush' id='size-normal' onClick={() => this.props.setLastAction('select_tool')} />
              <div className='size-brush' id='size-small' onClick={() => this.props.setLastAction('select_tool')} />
            </div>
            <div className='color-blk noselect'>
              <div className='color-picker-btn' onClick={this.handleColorOpen} />
              <div style={{display: this.state.displayColorPicker}} className='popover' ref={this.setWrapperRef}>
                <canvas id='color-picker' height='60' />
              </div>
            </div>
            <div className='text-blk noselect'>
              <div>
                <select className='font-option' defaultValue={'Arial'}
                  onChange={(e) => {
                    trackToolUsage('font');
                    this.props.setLastAction('select_tool');
                  }}>
                  <option value='Arial'>Arial</option>
                  <option value='Verdana'>Verdana</option>
                  <option value='Times New Roman'>Times New Roman</option>
                  <option value='Courier New'>Courier New</option>
                  <option value='serif'>serif</option>
                  <option value='sans-serif'>sans-serif</option>
                </select>
              </div>
              <div>
                <select className='text-size' defaultValue={'20px'}
                 onChange={(e) => {
                  trackToolUsage('text_size');
                  this.props.setLastAction('select_tool');
                }}>
                  <option value='4px'>4</option>
                  <option value='6px'>6</option>
                  <option value='8px'>8</option>
                  <option value='10px'>10</option>
                  <option value='12px'>12</option>
                  <option value='14px'>14</option>
                  <option value='16px'>16</option>
                  <option value='18px'>18</option>
                  <option value='20px'>20</option>
                  <option value='22px'>22</option>
                  <option value='24px'>24</option>
                  <option value='26px'>26</option>
                  <option value='28px'>28</option>
                  <option value='30px'>30</option>
                  <option value='32px'>32</option>
                  <option value='34px'>34</option>
                  <option value='36px'>36</option>
                </select>
                <span id='bold-btn'  
                onClick={() => {
                  this.setState(prevState => {
                    const newBoldState = !prevState.isBold;
                    if (newBoldState) {
                      trackToolUsage('bold');
                    }
                    return { isBold: newBoldState };
                  });
                  this.props.setLastAction('select_tool');
                }}>
                B
                </span>
                <span id='italic-btn'
                onClick={() => {
                  this.setState(prevState => {
                    const newItalicState = !prevState.isItalic;
                    if (newItalicState) {
                      trackToolUsage('italic');
                    }
                    return { isItalic: newItalicState };
                  });
                  this.props.setLastAction('select_tool');
                }}>
                I</span>
              </div>
            </div>
          </div>
          <div className='draw-submit-blk noselect'>
            <img src={process.env.PUBLIC_URL + '/assets/images/icons/Info.png'} alt='info' onClick={this.props.startTour} style={{'cursor': 'pointer'}} />
            <div className='draw-submit-btn disable submit-mask' onClick={this.props.save}>submit mask</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Header
